import { applyMiddleware, compose, createStore } from 'redux'
import { persistStore } from 'redux-persist'
import { createBrowserHistory } from 'history'

import createRootReducer from 'store/createRootReducer'
import createSagaMiddleware from 'redux-saga'
import rootSaga from 'store/sagas/rootSaga'

let persistor
const INITIAL_STATE = {}
const IS_DEV_ENVIRONMENT = process.env.NODE_ENV === 'development'

export const history = createBrowserHistory()

const configureStore = (initialState = INITIAL_STATE) => {
  const sagaMiddleWare = createSagaMiddleware()

  const composeWithReduxDevtools =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const middleware = [sagaMiddleWare]

  const appReducers = createRootReducer(history)

  const store = createStore(
    appReducers,
    initialState,
    composeWithReduxDevtools(applyMiddleware(...middleware))
  )

  if (IS_DEV_ENVIRONMENT && module.hot) { // REDUX Hot Module Replacement
    module.hot.accept('./createRootReducer', () => {
      store.replaceReducer(appReducers)
    })
  }

  persistor = persistStore(store)

  sagaMiddleWare.run(rootSaga)

  return { store, persistor }
}

export function getPersistor() {
  return persistor
}

export default configureStore
